import React from 'react';
import PropTypes from 'prop-types';

// FontAwesome.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// React-shared.
import Loader from '@exonet/react-shared/lib/Elements/Loader';

// App components.
import Button from 'app/client/components/Button';

// Styled.
import * as S from './styled';

const IconButton = ({ icon, small = false, onClick, children, alternate, disabled, isLoading }) => (
  <Button
    onClick={onClick}
    alternate={alternate}
    disabled={disabled}
    size={small ? 'small' : 'medium'}
  >
    <S.Icon hasChildren={children !== undefined}>
      {isLoading ? <Loader mini /> : <FontAwesomeIcon icon={icon} />}
    </S.Icon>
    {children}
  </Button>
);

IconButton.propTypes = {
  icon: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  alternate: PropTypes.bool,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  small: PropTypes.bool,
};

export default IconButton;
